export const color = {
  default_color_dark: '#7938D0',
  default_color: '#8954BA',
  default_color_light: '#9F67E9',
  default_color_background: '#d5cae5',
  selected_color: '#FBA61F',
  selected_color_dark: '#C68215',
  selected_highlight_color: '#F76A20',
};
